import { useEffect } from 'react';

import { hasToken } from '@app/utils';

interface UseAuthorizationEffectsProps {
  authorizeBySecretHandler: () => Promise<void>;
  clearAuthorizationAccessTokenHandler: () => void;
  hasUserAuthorized: boolean;
  isSecret: boolean;
  redirectAuthorizedHandler: () => void;
}

export const useAuthorizationEffects = ({
  authorizeBySecretHandler,
  clearAuthorizationAccessTokenHandler,
  hasUserAuthorized,
  isSecret,
  redirectAuthorizedHandler,
}: UseAuthorizationEffectsProps) => {
  useEffect(() => {
    if (!hasToken()) {
      clearAuthorizationAccessTokenHandler();
    }
  }, [clearAuthorizationAccessTokenHandler]);

  useEffect(() => {
    if (hasUserAuthorized) {
      redirectAuthorizedHandler();
    }
  }, [hasUserAuthorized, redirectAuthorizedHandler]);

  useEffect(() => {
    if (!hasUserAuthorized && isSecret) {
      void authorizeBySecretHandler();
    }
  }, [authorizeBySecretHandler, hasUserAuthorized, isSecret]);
};
